import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, catchError, throwError } from 'rxjs';
import { AuthRedirectService } from '../auth/auth-redirect.service';

/**
 * Must be registered as the FIRST interceptor in the chain so that it wraps
 * authHttpInterceptorFn. Auth0 token errors (e.g. "Missing Refresh Token")
 * are thrown inside authHttpInterceptorFn before the request reaches the
 * backend, so they propagate outward to this catchError.
 */
export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const authRedirect = inject(AuthRedirectService);

  return next(req).pipe(
    catchError((error) => {
      if (authRedirect.isAuthError(error)) {
        authRedirect.redirectToLogin();
        // Complete silently so polling streams don't crash
        return EMPTY;
      }
      return throwError(() => error);
    }),
  );
};
